import { Container, Grid, Typography } from "@mui/material";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import {
  StyledContent,
  StyledGridContainer,
  StyledTitle,
} from "@Styled/Pages/Prefooter";

const ReturnAndRefunds = () => {
  return (
    <>
      <Container sx={{ marginBottom: "5rem" }}>
        <StyledGridContainer container>
          <StyledHeadingWithGradientunderline
            variant="subtitle1"
            sx={{
              fontSize: { sm: "1.5rem", xs: "1.2rem" },
              letterSpacing: "-1px",
            }}
          >
            Return and refund Policy{" "}
          </StyledHeadingWithGradientunderline>
          <Grid item sm={12} style={{ marginTop: "1rem" }}>
            <StyledTitle style={{ paddingBottom: "0" }}>
              Return for a product will be accepted only if
            </StyledTitle>
            <ol>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                {" "}
                Order is received in damaged condition.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Wrong product is sent.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Part of the order is missing.
              </li>
            </ol>
          </Grid>
          <Grid>
            <StyledContent>
              In all of the above cases, customer shall inform us within 72
              hours of receiving the order with a valid image proof.
            </StyledContent>

            <ol>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                {" "}
                Only products worth same or more value would be eligible for
                exchange. No refunds will be processed.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Exchange product will be dispatched within 48-72 hours of
                receiving the request.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                A reverse pick up will be generated with our courier partner
                once the return/ exchange requested in accepted.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                In any case, if a prepaid order is not delivered a refund will
                be initiated within 3-5 working days via same mode of payment.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                If a customer wishes to return/exchange a product after 72 hours
                of delivery, the same should be couriered back at our facility
                after which a refund will be initiated within 3-5 days of
                receiving the product back at our warehouse. Courier charges
                will not be bared by ECONUT.
              </li>
            </ol>
            <StyledTitle style={{ paddingBottom: "0" }}>
              The tracking details for the same should be shared on{" "}
              <a
                href="mailto: customercare@econut.store"
                style={{ color: "#00844a" }}
              >
                customercare@econut.store
              </a>{" "}
            </StyledTitle>
            <ol>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                If an exchange is requested in the above case, order will be
                dispatched within 3-5 days of receiving the product back at our
                warehouse. To return/exchange a product, use our easy online
                returns process by logging in to your{" "}
                <a href="https://econut.store/" style={{ color: "#00844a" }}>
                  www.econut.store
                </a>{" "}
                account. You can also Call our customer Care Team on{" "}
                <a href="tel:+91-85913 67993" style={{ color: "#00844a" }}>
                  +91-85913 67993
                </a>{" "}
                (Working hours: Monday to Saturday, 10:00 am to 06:30 pm) or
                email us at{" "}
                <a
                  href="mailto: customercare@econut.store"
                  style={{ color: "#00844a" }}
                >
                  customercare@econut.store
                </a>{" "}
              </li>
            </ol>
            <StyledTitle style={{ paddingBottom: "0" }}>
              How do you return?
            </StyledTitle>
            <Typography style={{ fontSize: "1.2rem", padding: "0.5em 1rem" }}>
              Self-ship:
            </Typography>
            <StyledContent>
              you will have to self-ship the product(s) back to us, to reach our
              Returns Department. For all self-shipped returns, you will be
              reimbursed INR 100 towards your shipping costs as a voucher which
              can be used for future purchases on our website. The same is
              subject to your returns being inspected and quality checked on
              receipt in our warehouse.
            </StyledContent>
            <StyledContent>
              <strong>Address:</strong> Econut India pvt ltd 4. Udyog Kshetra,
              Off Goregaon Mulund Link Road, Mulund (west), Mumbai – 400080.
            </StyledContent>

            <StyledTitle style={{ paddingBottom: "0" }}>
              Cancellation policies:{" "}
            </StyledTitle>
            <ol>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                {" "}
                If a customer requests for a cancellation of prepaid order which
                is in transit, refund will be initiated only after the courier
                company confirms the same. This might take up to 7-9 days.
                ECONUT will not be responsible if the order is delivered. Time
                frame for initiating the refund will be 3-5 days after
                confirmation from the courier team.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Items bought individually or as whole during sale or offer
                period are not eligible for cancellation
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                <a href="https://econut.store/" style={{ color: "#00844a" }}>
                  www.econut.store
                </a>{" "}
                reserves the right to cancel any order without any explanation
                for doing so, as per the circumstances where the requirement
                could not be met. The company will ensure that any communication
                of cancellation of an order or any applicable refund will be
                made in reasonable time.
              </li>
            </ol>
            <StyledTitle style={{ paddingBottom: "0" }}>
              Cash On Delivery Policy{" "}
            </StyledTitle>
            <Typography
              style={{ fontSize: "1.2rem", padding: "0.5em 1rem 0 1rem" }}
            >
              As per the Cash on Delivery policy:{" "}
            </Typography>
            <ol>
              .
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                {" "}
                To avail C-O-D Service, all items in the cart should be
                applicable for C-O-D.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                C-O-D is applicable on a minimum sale value of Rs. 0 and maximum
                of Rs. 50,000 only.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Pin code provided for Cash on Delivery should be in the
                serviceable area. If not, any online payment mode needs to be
                used.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                You cannot open the box without making the payment at the time
                of delivery.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                If the product / box is open, do not accept the order.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                No credit/debit cards are accepted in Cash on Delivery.
              </li>
            </ol>
            <StyledTitle style={{ paddingBottom: "0" }}>
              Using Cash Back & Promo Codes/Coupons{" "}
            </StyledTitle>
            <ol>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                {" "}
                Cash back Promo Code may not be applicable for all the products
                on the website.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Special coupons should be redeemed within the limited period,
                and validity once expired, cannot be extended later.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Two offers cannot be clubbed together using the Promo Code.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                <a href="https://econut.store/" style={{ color: "#00844a" }}>
                  www.econut.store
                </a>{" "}
                reserves the right to cancel any promotional &apos;Promo
                Code&apos; and the transactions in which they are used. (This is
                not applicable on Cash back Promo Codes)
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Cash back and Promo Code /Coupon code cannot be clubbed together
                to avail an offer at{" "}
                <a href="https://econut.store/" style={{ color: "#00844a" }}>
                  www.econut.store
                </a>{" "}
                . This means, if Promo Code is used in an offer, Cash back
                cannot be generated.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Cash back amount is subject to change at the sole discretion{" "}
                <a href="https://econut.store/" style={{ color: "#00844a" }}>
                  www.econut.store
                </a>
                .{" "}
              </li>
            </ol>
            <StyledTitle style={{ paddingBottom: "0" }}>
              Images & Representations of Products/Services{" "}
            </StyledTitle>
            <StyledContent>
              Product Images are indicative in nature
            </StyledContent>
            <StyledContent>
              Actual Product may differ from the image. Please refer to the
              product specification for the product
            </StyledContent>
            <StyledTitle style={{ paddingBottom: "0" }}>
              For Queries/Comments{" "}
            </StyledTitle>
            <StyledContent style={{ paddingBottom: "0" }}>
              Send us your questions/queries or comments to{" "}
              <a
                href="mailto: customercare@econut.store"
                style={{ color: "#00844a" }}
              >
                customercare@econut.store
              </a>{" "}
            </StyledContent>
          </Grid>
        </StyledGridContainer>
      </Container>
    </>
  );
};
export default ReturnAndRefunds;
